import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";
import { media } from "@/lib/api";
import { fmtNum, fmtPrice, vTitle } from "@/lib/format";
import { StatusBadge } from "./ui";

export const VehicleCard = ({ v, to, index = 0, extra, priceLabel, footer, corner }) => {
  const { t, lang } = useLang();
  const cover = v.photos?.[0];
  const link = (
    <Link to={to || `/vehicle/${v.code}`} data-testid={`vehicle-card-${v.code}`} className={`group block min-w-0 ${footer ? "" : "xd-card fade-up"}`} style={footer ? undefined : { animationDelay: `${index * 60}ms` }}>
      <div className="relative aspect-[4/3] overflow-hidden bg-[#070707]">
        {cover ? (
          <img src={media(cover.id, "thumb")} alt={vTitle(v, lang)} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
        ) : (
          <div className="h-full w-full grid place-items-center text-zinc-800 text-4xl font-bold">XD</div>
        )}
        <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-black/70 to-transparent" />
        <StatusBadge status={v.availability} className="absolute top-3 start-3" />
      </div>
      <div className="p-5 space-y-2">
        <div className="flex items-start justify-between gap-3 min-w-0">
          <h3 className="text-lg font-medium text-white min-w-0 line-clamp-2 break-words leading-snug" title={vTitle(v, lang)}>{vTitle(v, lang)}</h3>
          <span className="text-[11px] text-zinc-500 ltr-num shrink-0 pt-1">{v.code}</span>
        </div>
        <p className="text-sm text-zinc-400 break-words">
          <span className="ltr-num">{v.year}</span> · <span className="ltr-num">{fmtNum(v.mileage)}</span> {t("unit.km")} · <span data-testid={`vehicle-card-hand-${v.code}`}>{t("spec.hand")} <span className="ltr-num">{v.hand}</span></span> · {t(`fuel.${v.fuel}`)}
        </p>
        <div className="xd-line !my-4" />
        {priceLabel && <p className="text-[11px] text-zinc-500">{priceLabel}</p>}
        <p className="text-xl font-semibold chrome-text ltr-num" data-testid={`vehicle-card-price-${v.code}`}>{fmtPrice(v.price)}</p>
        {extra}
      </div>
    </Link>
  );
  if (corner && !footer) return <div className="relative min-w-0">{link}<div className="absolute top-3 end-3 z-10">{corner}</div></div>;
  if (!footer) return link;
  return (
    <div className="xd-card fade-up min-w-0 flex flex-col" style={{ animationDelay: `${index * 60}ms` }} data-testid={`vehicle-card-wrap-${v.code}`}>
      {link}
      <div className="mt-auto px-5 pb-5 pt-4 border-t border-white/5">{footer}</div>
    </div>
  );
};

export const VehicleGrid = ({ items, linkFor, extraFor, footerFor, cornerFor, priceLabel }) => (
  <div className="grid gap-5 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 min-w-0">
    {items.map((v, i) => <VehicleCard key={v.id} v={v} index={i} to={linkFor?.(v)} extra={extraFor?.(v)} footer={footerFor?.(v)} corner={cornerFor?.(v)} priceLabel={priceLabel} />)}
  </div>
);
